// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__k4QeL","head":"Table_head__3KIj_","col":"Table_col__390k2"};